module.exports = __webpack_public_path__ + "static/media/personne-malentendante-questions.bf515d33.png";